// This file is auto-generated by @hey-api/openapi-ts

/**
 * Customer card base type.
 */
export const CustomerCardBaseTypesEnum = { ANONYMOUS: 'ANONYMOUS', PERSONAL: 'PERSONAL' } as const;

/**
 * Customer card base type.
 */
export type CustomerCardBaseTypesEnum = typeof CustomerCardBaseTypesEnum[keyof typeof CustomerCardBaseTypesEnum];
